// Left rail: tabs for Elements, Fields, Layers, Images and Theme.

import React from "react";
import FeatherIcon from "feather-icons-react";

export const RAIL_TABS = [
  { id: "elements", label: "Elements", icon: "plus-square" },
  { id: "fields", label: "Fields", icon: "hash" },
  { id: "layers", label: "Layers", icon: "layers" },
  { id: "assets", label: "Images", icon: "image" },
  { id: "theme", label: "Theme", icon: "droplet" },
];

export default function LeftRail({ tab, onTab, children }) {
  return (
    <aside className="td-rail" aria-label="Design tools">
      <div className="td-rail__tabs" role="tablist" aria-orientation="vertical">
        {RAIL_TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            id={`td-tab-${t.id}`}
            aria-selected={tab === t.id}
            aria-controls="td-rail-panel"
            className={`td-rail__tab${tab === t.id ? " is-active" : ""}`}
            onClick={() => onTab(t.id)}
          >
            <FeatherIcon icon={t.icon} size={17} />
            <span>{t.label}</span>
          </button>
        ))}
      </div>
      <div className="td-rail__panel" id="td-rail-panel" role="tabpanel" aria-labelledby={`td-tab-${tab}`}>
        {children}
      </div>
    </aside>
  );
}
